// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Home__wrapper__2U00u","stars":"Home__stars__1e7P6","animStar":"Home__animStar__c2cvd","stars2":"Home__stars2__39S5X","btn":"Home__btn__2tTan","rotateArrow":"Home__rotateArrow__3RJOK","flex":"Home__flex__DHpC5","highlight":"Home__highlight__1PZHO","text":"Home__text__3RxH2"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Home/Home.css
// module id = 28
// module chunks = 0